import { AxiosResponse } from 'axios';
import { IPackingTrackingApi, api } from '../base';
import { GetPackageManagementResponse, IGetPackageDetailsResponse, QuoteResponseCount } from '@/main/models/response';
import { QuoteCountStatusRequest } from '@/main/models/request';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { GetPackageManagementFilterRequest } from '@/main/models/request/packingTrackingRequest';
import { Result } from '@/main/models/common/resultResponse';

const baseRoute: string = 'PackingTracking';

export class PackingTrackingApi extends IPackingTrackingApi {
  private activeAbortController: AbortController | null = null;

  async getPackageManagement(
    request: GetPackageManagementFilterRequest
  ): Promise<AxiosResponse<PaginationResponse<GetPackageManagementResponse>>> {
    if (this.activeAbortController) {
      this.activeAbortController.abort();
    }
    this.activeAbortController = new AbortController();
    const response = await api.get(`${baseRoute}/getPackageManagement`, {
      params: request,
      signal: this.activeAbortController.signal
    });
    this.activeAbortController = null;
    return response;
  }

  getPackageDetails(
    guidPackingTracking: string
  ): Promise<
    AxiosResponse<Result<IGetPackageDetailsResponse>>
  > {
    return api.get(`${baseRoute}/getPackageDetails`, { params: { guidPackingTracking } });
  }

  countPackageStatus(
    request: QuoteCountStatusRequest
  ): Promise<AxiosResponse<Result<QuoteResponseCount[]>>> {
    return api.get(`${baseRoute}/countpackagestatus`, { params: request });
  }
}